<script setup lang="ts">
import PdsBadge from '@/components/pds/PdsBadge.vue';
import PdsButton from '@/components/pds/PdsButton.vue';
import { formatDate, formatMoney, formatTime } from '../format';
import { useRoute } from 'vue-router';
import type { HistoryRow } from '../history';
import { orderLink } from '../orderLink';

defineProps<{ rows: HistoryRow[] }>();
const route = useRoute();
</script>

<template>
  <ul class="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
    <li
      v-for="row in rows"
      :key="row.id"
      class="bg-carte flex flex-col gap-[10px] rounded-[24px] p-6"
      data-testid="history-card"
    >
      <header class="flex h-7 items-center gap-3">
        <span class="shrink-0 text-[18px] leading-[1.2] font-bold">
          #{{ row.orderNumber ?? row.number }}
        </span>
        <span
          class="text-encre-douce min-w-0 flex-1 truncate text-[12px] leading-[1.45]"
        >
          {{ row.label }}
        </span>
        <PdsBadge :tone="row.negative ? 'late' : 'closed'">
          {{ row.state }}
        </PdsBadge>
      </header>

      <p
        class="flex flex-wrap gap-x-[5px] text-[24px] leading-[28px] font-bold tracking-[-0.4px] whitespace-nowrap"
      >
        <span>{{ formatDate(row.day) }}</span>
        <span>· {{ formatTime(row.day) }}</span>
      </p>

      <p class="text-encre-douce text-[12px] leading-[1.45]">
        <template v-if="row.itemCount !== null">
          {{ row.itemCount }} article{{ row.itemCount > 1 ? 's' : '' }} ·
        </template>
        <span :class="row.negative && 'text-alerte-texte'">
          {{ row.negative ? '−' : '' }}{{ formatMoney(row.amountCents) }}
        </span>
      </p>

      <p
        v-if="row.detail"
        class="bg-creux w-fit max-w-full rounded-[8px] px-[10px] py-[6px] text-[12px] leading-[1.45]"
      >
        {{ row.detail }}
      </p>

      <div class="flex">
        <PdsButton variant="second" :to="orderLink(row.id, route.fullPath)">
          Ouvrir
        </PdsButton>
      </div>
    </li>
  </ul>
</template>
